import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { purifier, addScript } from '../../../utils/dom';
import s from './Embed.scss';

const Embed = ({ content }) => {
	useEffect(() => {
		if (content.rawText.indexOf('tradeinroot') !== -1) {
			window.shopId = '64dfe63914c20849d7f6a2e0';
			window.hashRouter = true;
			addScript('https://tradein.create2stay.com/static/tradein.js')
				.catch(() => {
					// Empty. In case script already loaded.
				});
		}

		return () => {
			[...document.querySelectorAll('.js-embedScripts')].map((node) => node && node.remove());
		};
	}, []);

	return (
		<div className={s.embed} dangerouslySetInnerHTML={{ __html: purifier(content.rawText) }} />
	);
};

export default hot(module)(Embed);
